import { FETCH_RAINPRO_POINTS, CLEAN_RAINPRO_POINTS, CHANGE_RAINPRO_POINT, DELETE_RAINPRO_POINT } from '../actions/types';
import _ from 'lodash';
import { toNumber } from '../functions';

const RAINPRO_POINTS_DEFAULT_STATE = {};

const RainproPointsReducer = (state = RAINPRO_POINTS_DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case FETCH_RAINPRO_POINTS:
            return payload;

        case CHANGE_RAINPRO_POINT:
            return { ...state, items: _.map(state.items, item => {
                if (toNumber(item.id) === toNumber(payload.id)) {
                    item = { ...item, data: payload.data };
                }

                return item;
            }) };

        case CLEAN_RAINPRO_POINTS:
        case DELETE_RAINPRO_POINT:
            return RAINPRO_POINTS_DEFAULT_STATE;

        default:
            return state;
    }
};

export default RainproPointsReducer;
